import * as React from 'react';
import {
  OutboundLink,
  OutboundLinkProps,
} from 'gatsby-plugin-google-analytics';

export const OutLink = ({
  to,
  target = '_BLANK',
  rel = target === '_BLANK' ? 'noopener noreferrer' : undefined,
  ...props
}: OutboundLinkProps & { to: string } & Omit<
    JSX.IntrinsicElements['a'],
    'ref'
  >) => <OutboundLink href={to} target={target} rel={rel} {...props} />;
